import React, { useState, useEffect } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Input,
  Spinner
} from "reactstrap";
import Select from "react-select";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { getActiveUserListAPIURL, getUserPermissionAPIURL, patchUserPermissionAPIURL } from 'BaseComponentAPI/UserCallPermissionAPI';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import { get, post } from "helpers/api_helper";
import axios from 'axios';
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';
import { useSelector } from "react-redux";
import { useFormik } from "formik";


const UserCallPermission = () => {

  document.title = "User Call Permission | Cockpit";

  const [selectedUser, setSelectedUser] = useState(null);
  const [callTypes, setCallTypes] = useState([]);
  const [loadingSwitch, setLoadingSwitch] = useState(null);
  const [debounceTimers, setDebounceTimers] = useState({});

  const authUser = useSelector(state => state.Login);
  const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
  const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);
  
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
  const [popupType, setPopupType] = useState('');  // Set the type from passed state


  useEffect(() => {
        getUserList();
    }, [authUser]);

  // Dummy users (Replace with API)
  // const users = [
  //   { value: "1", label: "GPtc1 - Deepti" },
  //   { value: "2", label: "GPtc2 - Dhanashree" },
  //   { value: "3", label: "GPtc3 - Amruta" }
  // ];

  // Simulate fetch after user select
  const fetchPermissions = async (user) => {
    // const dummy = [
    //   { id: 1, name: "Live Calls", enabled: true },
    //   { id: 2, name: "System Follow Ups", enabled: false },
    //   { id: 3, name: "Cold Calls", enabled: true },
    //   { id: 4, name: "Missed Calls", enabled: false }
    // ];

// alert(user[0]);
//   const permissions  =[
//         {
//             "groupName": "Group 1",
//             "groupNo": 1,
//             "groupAccess": false
//         },
//         {
//             "groupName": "Group 2",
//             "groupNo": 2,
//             "groupAccess": false
//         },
//         {
//             "groupName": "Group 3",
//             "groupNo": 3,
//             "groupAccess": true
//         },
//         {
//             "groupName": "Group 4",
//             "groupNo": 4,
//             "groupAccess": true
//         },
//         {
//             "groupName": "Group 5",
//             "groupNo": 5,
//             "groupAccess": false
//         },
//         {
//             "groupName": "Group 6",
//             "groupNo": 6,
//             "groupAccess": false
//         }
//     ]

    setCallTypes(permissions);
  };

  //const handleUserChange = (user) => {
   const handleUserChange = async (user) => { 
    // setSelectedUser(user);
    // setCallTypes([]);
    // fetchPermissions(user);

    setSelectedUser(user);
    setCallTypes([]);
    await getUserCallPermissions(user.value);
  };

  // 🔥 ENTERPRISE TOGGLE HANDLER
  const handleToggle_old = (id) => {
    const previousState = [...callTypes];

    const updated = callTypes.map(type =>
      type.id === id ? { ...type, enabled: !type.enabled } : type
    );

    // ✅ Optimistic UI update
    setCallTypes(updated);

    // Clear previous debounce timer
    if (debounceTimers[id]) {
      clearTimeout(debounceTimers[id]);
    }

    const timer = setTimeout(async () => {
      try {
        setLoadingSwitch(id);

        const changedItem = updated.find(t => t.id === id);

        await post("/api/update-user-call-permission", {
          userUUID: selectedUser.value,
          callTypeId: id,
          enabled: changedItem.enabled
        });

        toast.success("Permission updated successfully");

      } catch (error) {
        // ❌ Revert on error
        setCallTypes(previousState);
        toast.error("Failed to update permission");
      } finally {
        setLoadingSwitch(null);
      }
    }, 500); // 500ms debounce

    setDebounceTimers(prev => ({ ...prev, [id]: timer }));
  };

const handleToggle = (groupNo) => {

  const previousState = [...callTypes];

  const updated = callTypes.map(type =>
    type.groupNo === groupNo
      ? { ...type, groupAccess: !type.groupAccess }
      : type
  );

  setCallTypes(updated); // ✅ optimistic update

  if (debounceTimers[groupNo]) {
    clearTimeout(debounceTimers[groupNo]);
  }

  const timer = setTimeout(async () => {
    try {
      setLoadingSwitch(groupNo);

      const changedItem = updated.find(t => t.groupNo === groupNo);

      await axios.patch(
        `${patchUserPermissionAPIURL}`,
        {
          employeeUUID: selectedUser.value,
          groupNo: groupNo,
          groupAccess: changedItem.groupAccess
        },
        {
          headers: {
            ...authUser.headers,
            Authorization: `Bearer ${authUser.headers.access_token}`
          }
        }
      );

      toast.success("Permission updated");

    } catch (error) {
      setCallTypes(previousState); // ❌ revert on failure
      toast.error("Failed to update permission");
    } finally {
      setLoadingSwitch(null);
    }

  }, 500); // debounce 500ms

  setDebounceTimers(prev => ({ ...prev, [groupNo]: timer }));
};
const getUserList = async () => {
    setLoadingUsers(true);

    if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            try {
                    
                const response = await axios.get(
                            `${getActiveUserListAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                            {
                                headers: { ...authUser.headers },
                                'Authorization': `Bearer ${authUser.headers.access_token}`
                            }
                        );        

                if (response?.data?.responseCode === 0) {
                const userOptions =
                    response.data.data.items?.map(user => ({
                    value: user.userUUID,
                    label: `${user.firstName} ${user.lastName} ( ${user.userName} )`,
                    })) || [];

                setUserOptions(userOptions);                
                }
                else
                {
                    console.error('API Response Error:', response.data.responseMsg);
                    //setLoaderOption(false);
                    openPopup('Something went wrong!', 'error')
                }
            } catch (error) {
                console.error("Error fetching telecaller list", error);
                openPopup('Something went wrong!', 'error')
                
            } finally {
                setLoadingUsers(false);
            }
    }
    };


const getUserCallPermissions = async (employeeUUID) => {
  setLoadingUsers(true);

  try {
    const response = await axios.get(
      `${getUserPermissionAPIURL}?employeeUUID=${employeeUUID}`,
      {
        headers: {
          ...authUser.headers,
          Authorization: `Bearer ${authUser.headers.access_token}`
        }
      }
    );

    if (response?.data?.responseCode === 0) {
      setCallTypes(response.data.data);  // assuming API returns group list
    } else {
      toast.error(response.data.responseMsg || "Failed to load permissions");
    }

  } catch (error) {
    toast.error("Error fetching permissions");
  } finally {
    setLoadingUsers(false);
  }
};

const getUserCallPermissions_old = async () => {
    setLoadingUsers(true);

    if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            try {
                    
                const response = await axios.get(
                            `${getUserPermissionAPIURL}?employeeUUID=${authUser.headers.userUUID}`,
                            {
                                headers: { ...authUser.headers },
                                'Authorization': `Bearer ${authUser.headers.access_token}`
                            }
                        );        

                if (response?.data?.responseCode === 0) {
                const userOptions =
                    response.data.data.items?.map(user => ({
                    value: user.userUUID,
                    label: `${user.firstName} ${user.lastName} ( ${user.userName} )`,
                    })) || [];

                setUserOptions(userOptions);                
                }
                else
                {
                    console.error('API Response Error:', response.data.responseMsg);
                    //setLoaderOption(false);
                    openPopup('Something went wrong!', 'error')
                }
            } catch (error) {
                console.error("Error fetching telecaller list", error);
                openPopup('Something went wrong!', 'error')
                
            } finally {
                setLoadingUsers(false);
            }
    }
    };




  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Call Center" breadcrumbItem="User Call Permission" />

          <Row className="justify-content-center">
            <Col xs="12" sm="12" md="10" lg="8" xl="6">
              <Card>
                <CardBody>

                  {/* User Selection */}
                  <div className="mb-4">
                    <Label className="fw-bold">Select User</Label>
                    <Select
                      value={selectedUser}
                      //onChange={getUserCallPermissions}
                      options={userOptions}
                      placeholder="Select User"
                      onChange={value => handleUserChange(value)}
                      //value={formik.values.selectedUser}    
                      maxMenuHeight={100}
                      //onChange={value =>
                        //fetchPermissions(value)
                          //formik.setFieldValue("selectedUser", value)
                      //} 
                      // onBlur={() =>
                      //     //formik.setFieldTouched("selectedUser", true)
                      // } 
                    />
                  </div>

                  {/* Switch List */}
                  {selectedUser && callTypes.length > 0 && (
                    <Row>
                      {callTypes.map(type => (
                        <Col xs="12" sm="6" key={type.groupNo} className="mb-3">
                          <div className="permission-box p-3 rounded d-flex justify-content-between align-items-center">

                            <span>{type.groupName}</span>

                            <div className="d-flex align-items-center">

                              {loadingSwitch === type.groupNo && (
                                <Spinner size="sm" className="me-2" />
                              )}

                              <div className="form-check form-switch">
                                <Input
                                  type="switch"
                                  className="custom-switch"
                                  checked={type.groupAccess}
                                  onChange={() => handleToggle(type.groupNo)}
                                  disabled={loadingSwitch === type.groupNo}
                                />
                              </div>

                            </div>

                          </div>
                        </Col>
                      ))}
                    </Row>
                  )}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserCallPermission;
